var Trig = {
	distanceBetween2Points: function ( point1, point2 ) {
		var dx = point2.x - point1.x;
		var dy = point2.y - point1.y;
		return Math.sqrt( Math.pow( dx, 2 ) + Math.pow( dy, 2 ) );
	},
	angleBetween2Points: function ( point1, point2 ) {	
		var dx = point2.x - point1.x;
		var dy = point2.y - point1.y;
		return Math.atan2( dx, dy );
	}
}

function Sketcher( canvasID, brushImage ) {
	this.renderFunction = (brushImage == null || brushImage == undefined) ? this.updateCanvasByLine : this.updateCanvasByBrush;
	this.brush = brushImage;
	//this.touchSupported = Modernizr.touch;
	this.canvasID = canvasID;
	//this.canvas = $("#"+canvasID);
	this.canvas = document.getElementById(canvasID);
	this.context = this.canvas.getContext("2d");	
	//console.log('context', this.context);
	this.context.strokeStyle = "#000000";
	this.context.lineWidth = 3;
	this.lastMousePoint = {x:0, y:0};
	this.brushMode = 'normal';
	this.customBrushes = [];
	this.loadBrushes();
	
	if (this.touchSupported) {
		this.mouseDownEvent = "touchstart";
		this.mouseMoveEvent = "touchmove";
		this.mouseUpEvent = "touchend";
	}
	else {
		this.mouseDownEvent = "mousedown";
		this.mouseMoveEvent = "mousemove";
		this.mouseUpEvent = "mouseup";
	}

	window.addEventListener("mousedown", this.onCanvasMouseDown(), false);
	window.addEventListener("mouseover", this.onCanvasMouseDown(), false);
}


Sketcher.prototype.onCanvasMouseDown = function () {
	var self = this;
	// console.log('mousedown');
	return function(event) {
		self.mouseMoveHandler = self.onCanvasMouseMove()
		self.mouseUpHandler = self.onCanvasMouseUp()

		window.addEventListener("mousemove", self.mouseMoveHandler );
		window.addEventListener("mouseup", self.mouseUpHandler );
		
		self.updateMousePosition( event );
		self.renderFunction( event );
	}
}

Sketcher.prototype.onCanvasMouseMove = function () {
	var self = this;
	// console.log('mousemove');
	return function(event) {

		self.renderFunction( event );
		 event.preventDefault();
		return false;
	}
}

Sketcher.prototype.onCanvasMouseUp = function (event) {
	var self = this;
	// console.log('mouseup');
	return function(event) {
		window.removeEventListener("mousemove", self.mouseMoveHandler );
		window.removeEventListener("mouseup", self.mouseUpHandler );
		
		self.mouseMoveHandler = null;
		self.mouseUpHandler = null;
	}
}

Sketcher.prototype.updateMousePosition = function (event) {
	var target;
	if (this.touchSupported) {
		target = event.originalEvent.touches[0]
	}
	else {
		target = event;
	}
	
	//var offset = { left: this.canvas.offsetWidth, top: this.canvas.offsetHeight };
	
	//this.lastMousePoint.x = target.pageX - offset.left;
	//this.lastMousePoint.y = target.pageY - offset.top;

	//console.log('can', this.canvas.offsetHeight, target.pageY );

	var halfBrushW = this.brush.width/2;
	var halfBrushH = this.brush.height/2;
	//console.log('hbh', halfBrushH, halfBrushW);
	this.lastMousePoint.x = target.pageX - halfBrushW;
	this.lastMousePoint.y = target.pageY - halfBrushH;
	
}

Sketcher.prototype.updateCanvasByLine = function (event) {

	this.context.beginPath();
	this.context.moveTo( this.lastMousePoint.x, this.lastMousePoint.y );
	this.updateMousePosition( event );
	this.context.lineTo( this.lastMousePoint.x, this.lastMousePoint.y );
	this.context.stroke();
}

Sketcher.prototype.updateCanvasByBrush = function (event) {
	var halfBrushW = this.brush.width/2;
	var halfBrushH = this.brush.height/2;
	
	var start = { x:this.lastMousePoint.x, y: this.lastMousePoint.y };
	this.updateMousePosition( event );
	var end = { x:this.lastMousePoint.x, y: this.lastMousePoint.y };
	
	var distance = parseInt( Trig.distanceBetween2Points( start, end ) );
	var angle = Trig.angleBetween2Points( start, end );
	
	var x,y;
	var lastDisco;
	for ( var z=0; (z<=distance || z==0); z++ )
	{
		x = start.x + (Math.sin(angle) * z) - halfBrushW;
		y = start.y + (Math.cos(angle) * z) - halfBrushH;

		y = y + halfBrushH*1.5;

		var rect = this.canvas.getBoundingClientRect();

		//console.log( x, y, angle, z, halfBrushW, halfBrushH );
		// console.log('y', y,  window.scrollY, y - window.scrollY);
		//subtract window scroll to compensate for where convas starts
		if (this.brushMode == 'disco') {
			//const sel = document.querySelector('#selectedBrush');
			// const brushOptions = sel.querySelectorAll('option');
			// console.log(brushOptions[Math.floor(Math.random()*brushOptions.length)].value);


			let choice = Math.floor(Math.random()*this.customBrushes.length);
			this.context.drawImage(this.customBrushes[choice], x, y - window.scrollY - rect.top, halfBrushW, halfBrushH);
		} else {
			// this.context.drawImage(this.brush, x, y, halfBrushW, halfBrushH);
			

			this.context.drawImage(this.brush, x, y - window.scrollY - rect.top, halfBrushW, halfBrushH);
			
		}


		

		// let brushW = halfBrushW + Math.floor(Math.random() * 10);
		// let brushH = halfBrushH + Math.floor(Math.random() * 10);
		// this.context.drawImage(this.brush, x, y, brushW, brushH);
		// this.context.rotate(1 * Math.PI);
	}
}

Sketcher.prototype.loadBrushes = function() {
	const sel = document.querySelector('#selectedBrush');
	const brushOptions = sel.querySelectorAll('option');
	for(var i=0; i < brushOptions.length; i++){
		this.customBrushes[i] = new Image();
		this.customBrushes[i].src = brushOptions[i].value;
	}
}

Sketcher.prototype.changeBrush = function (brushSrc) {
	this.brush.src = brushSrc;
}

Sketcher.prototype.toggleDisco = function () {
	this.brushMode = (this.brushMode == 'disco') ? 'normal' : 'disco';
}

Sketcher.prototype.clear = function () {
	var c = this.canvas;
	this.context.clearRect( 0, 0, c.width, c.height );
}

window.Sketcher = Sketcher;

/*
//sketching with a brush
const $sketch = document.querySelector('#sketch');
if ($sketch) {
	console.log('has sketcher');
	var brush = new Image();
	var selectedBrush = document.querySelector('#selectedBrush');

	//brush.src = '/assets/images/ui/rake-shortstuff-cropped.png';
	brush.src = selectedBrush.value;
	// console.log('brush', brush);
	
	brush.onload = function(){
		let canvas = document.getElementById("sketch");
		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;
		sketcher = new Sketcher( "sketch", brush );
		console.log('sketcher', sketcher);
		
		// const sel = document.querySelector('#selectedBrush');
		// var brushOptions = sel.querySelectorAll('option');
		// console.log('bo', brushOptions);
		// for(var i = 0; i < brushOptions.length; i++) {
		// 	console.log('o', brushOptions[i].value);
			
		// }
		// brushOptions.forEach(b => {
		// 	console.log('o', b.value);
		// // 	//sketcher.brushes.push(b.value);
	   	// });
	}
}
*/